import React from 'react';
import { Box, Typography } from '@curves/ui-base';

/**
 * 「本次不兌換」二次確認的內容元件（MessageDialog 的 msg 只吃字串，故走 MsgComp）。
 * sourceItems 是後端已扣點的既有兌換，不兌換會被取消；draftItems 是本頁草稿，不會送出。
 */
const UnredeemConfirmMessage = ({ sourceItems = [], draftItems = [] }) => (
    <Box className="redeem-unredeem-confirm">
        <Typography className="redeem-unredeem-confirm__lead">
            選擇本次不兌換後，本期將不會兌換任何商品。
        </Typography>

        {sourceItems.length > 0 && (
            <Box className="redeem-unredeem-confirm__section">
                <Typography className="redeem-unredeem-confirm__label">原已確認兌換（將取消）</Typography>
                {sourceItems.map((item) => (
                    <Box key={item.itemID} className="redeem-unredeem-confirm__row">
                        <Typography component="span" className="redeem-unredeem-confirm__name">
                            {item.itemName}
                        </Typography>
                        <Typography component="span" className="redeem-unredeem-confirm__qty">
                            × {item.quantity}
                        </Typography>
                    </Box>
                ))}
            </Box>
        )}

        {draftItems.length > 0 && (
            <Box className="redeem-unredeem-confirm__section">
                <Typography className="redeem-unredeem-confirm__label">目前清單已選（不會送出）</Typography>
                {draftItems.map((item) => (
                    <Box key={item.itemID} className="redeem-unredeem-confirm__row">
                        <Typography component="span" className="redeem-unredeem-confirm__name">
                            {item.itemName}
                        </Typography>
                        <Typography component="span" className="redeem-unredeem-confirm__qty">
                            × {item.quantity}
                        </Typography>
                    </Box>
                ))}
            </Box>
        )}

        <Typography className="redeem-unredeem-confirm__hint">確定要本次不兌換嗎？</Typography>
    </Box>
);

export default UnredeemConfirmMessage;
